export default {
  FETCH_MARKETPLACE_REQUEST: 'FETCH_MARKETPLACE_REQUEST',
  FETCH_MARKETPLACE_SUCCESS: 'FETCH_MARKETPLACE_SUCCESS',
  FETCH_MARKETPLACE_FAILURE: 'FETCH_MARKETPLACE_FAILURE'
}
